import { EventEmitter } from 'events';

const NoticeEmitter = new EventEmitter();
export default NoticeEmitter;


// WEBPACK FOOTER //
// ./src/utils/NoticeUtil.js